import { useContext, useState } from "react"
import UiButton1 from "./ui_button1"
import { AppContext } from "./context"
import UiSpinner from "./ui_spinner"

const BrandGoalsDeleteYear = () => {

    const [load, setLoad] = useState(false)
    const [error, setError] = useState("")

    const {
        selectedYearMarketplace, setSelectedYearMarketplace,
        setReloadYearMarketplace,
        offCanvas,
        setPopupSidebarType,
        setSideBarTitle,
        setToastContent,
        toastInit,
        fetchDataV2
    } = useContext(AppContext)

    const deleteYear = async () => {
        setError("")
        setLoad(true)

        let query1 = "DELETE_GOAL_YEAR_1", params1 = [selectedYearMarketplace.id]
        let query2 = "DELETE_GOAL_YEAR_2", params2 = [selectedYearMarketplace.id]

        try {
            await Promise.all([
                fetchDataV2(query1, params1, "/neon-query-v2"),
                fetchDataV2(query2, params2, "/neon-query-v2"),
                fetchDataV2("DELETE_YEAR_BQ", { brand_year_marketplace_id: selectedYearMarketplace.id }, "/bigquery-sql-v2"),
            ])
            setToastContent("Goal data deleted.")
            toastInit.show()
            offCanvas.hide()
            setPopupSidebarType("")
            setSideBarTitle("")
            setSelectedYearMarketplace(null)
            setReloadYearMarketplace(true)
        }
        catch (err) {
            setError("Someting went wrong! " + err)
            return
        }
        finally {
            setLoad(false)
        }
    }

    return (
        <div className="d-flex flex-column justify-content-between h-100">
            {error && <p className="poppins text-danger">{error}</p>}
            <p className="poppins">Are you sure you want to delete this marketplace year '{selectedYearMarketplace.country_code} {'>'} {selectedYearMarketplace.year}'?</p>
            {load ?
                <UiSpinner />
                :
                <UiButton1 text="Delete" submit={deleteYear} />
            }
        </div>
    )
}

export default BrandGoalsDeleteYear